export default __webpack_public_path__ + "static/media/francheville18.731354e3.jpg";